define(['moment'], (moment) => {
    return ['$q', '$http', 'configBasler', 'CallTrackerService', 'ContextService',
        function ($q, $http, ConfigBasler, CallTrackerService, ContextService) {
            let uniqueVehicleId;
            let firstRegistration;
            const service = {
                // Filter out SOLR Special Chars
                escapeUserInput: function (userInput) {
                    return userInput.replace(/[\+\-\&\&\|\|\(\{\}\[\]\^\"\~\*\?\:\\]/gi, ' ').trim();
                },
                send: function (userInput, firstRegistrationDate, isMotorcycleMode, callGroups) {
                    // The spec for the code of this function can be found here: https://confluence.baloisenet.com/atlassian/x/kQmYRw
                    const defaultDuration = 4;
                    const fromDate = new Date(firstRegistrationDate);
                    fromDate.setFullYear(fromDate.getFullYear() - defaultDuration);
                    const firstRegistrationDateMonthStart = new Date(firstRegistrationDate);
                    firstRegistrationDateMonthStart.setHours(0);
                    firstRegistrationDateMonthStart.setMinutes(0);
                    firstRegistrationDateMonthStart.setSeconds(0);
                    let firstRegistrationDateMonthEnd = new Date(firstRegistrationDateMonthStart);
                    firstRegistrationDateMonthEnd.setMonth(firstRegistrationDateMonthStart.getMonth() + 1);
                    // Note: vehice data returned from the service contain 'preisBeginn' date in UTC format
                    // e.g.: 2015-12-31T23:00:00Z
                    // to handle the month correctly (2016-01 in this case instead of 2015-12)
                    // for the query the date will be decreased by one minute to be sure it is below 23h
                    // additional info:
                    // it seems that if a vehicle got into the DB during wintertime
                    // the time for 'preisBeginn' is 23:00. For summertime it is 22:00.
                    firstRegistrationDateMonthEnd = moment(firstRegistrationDateMonthEnd)
                        .subtract(1, 'minute')
                        .toDate();

                    //select only needed fields e.g. 'uniqueVehicleIdentifier' is technical and not needed at all
                    const flParam = 'id, eurotaxNumber, markenName, typenscheinNummer, importBeginn, importEnde, preisBeginn, co2Emission, fahrzeugtyp, anzahlPlaetze, leerGewicht, gesamtGewicht, treibstoffart, karosserieart, getriebeart, modelName, typName, kw, ps, preis, tueren, preisEnde, hubraum, checksum, leistungsgewicht';

                    const searchString = callGroups === 'searchUniqueVehicle' ? `uniqueVehicleIdentifier:"${userInput}"` : `text:*${service.escapeUserInput(userInput)}*`;

                    const preisEnde = new Date(firstRegistrationDateMonthStart);
                    preisEnde.setMonth(preisEnde.getMonth() - 6);
                    // Do not use ESLint Template String
                    let queryParam = '((' + searchString +
                        ' AND preisBeginn:[* TO ' + firstRegistrationDateMonthEnd.toJSON() + ']' +
                        ' AND preisEnde:[' + preisEnde.toJSON() + ' TO *]' +
                        ' AND NOT preisEnde:[9999-01-01T00:00:00Z TO 9999-12-31T23:59:59Z])' +
                        ' OR (' + searchString + ' AND preisEnde:[ 9999-01-01T00:00:00Z TO 9999-12-31T23:59:59Z] AND preisBeginn:[' + fromDate.toJSON() + ' TO ' + firstRegistrationDateMonthEnd.toJSON() + ']))';

                    if (isMotorcycleMode) {
                        queryParam += ' AND typenscheinNummer:6* AND (anzahlPlaetze:1 OR anzahlPlaetze:2)';
                    } else {
                        queryParam += ' AND NOT typenscheinNummer:6* AND NOT gesamtGewicht:0 AND NOT leerGewicht:0';
                    }

                    // Don't allow the vehicles heavier as 3.5 tons (GALRE-49565)
                    queryParam += ' AND gesamtGewicht:[0 TO 3500]';

                    const sortParam = [
                        'markenName asc',
                        'typName asc',
                        'typenscheinNummer asc',
                        'preis asc',
                        'ps asc',
                    ].join(', ');

                    const compiledQuery = {
                        params: {
                            fl: flParam, //fields in a result
                            q: `\{!q.op=AND}${queryParam}`, //query
                            sort: sortParam,
                            wt: 'json', //format of results
                            group: true, //grouping enabled
                            'group.field': 'uniqueVehicleIdentifier', //group by 'uniqueVehicleIdentifier'
                            'group.main': true, //return grouped results in an old good format
                            rows: 100,
                        },
                    };

                    CallTrackerService.registerCallStart(callGroups);
                    return ($http.get(ConfigBasler.vehicleSearch.solrUrl, compiledQuery).then((response) => {
                                CallTrackerService.registerCallSuccess(callGroups);
                                return response;
                            }, (error) => {
                                CallTrackerService.registerCallError(callGroups);
                                return $q.reject(error);
                            })
                    );

                }, //send
                presetVehicleInformation: (id, year, month) => {
                    if (month && year) {
                        firstRegistration = new Date(year, month, 1);
                    }
                    uniqueVehicleId = id;
                },
                getPresetVehicle: () => {
                    return service.send(uniqueVehicleId, firstRegistration, ContextService.isMotorcycleMode(), 'searchUniqueVehicle');
                },
                getPresetFirstRegistration: () => firstRegistration,
                isPresetInformationAvailable: () => firstRegistration && uniqueVehicleId,
            };
        return service;
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/services/BaslerVehicleSearchService.js